export class NativeStreamMapOutputType {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamMapOutputKind",
            "format": ""
        },
        {
            "name": "keys",
            "baseName": "keys",
            "type": "NativeStreamMapKeyType",
            "format": ""
        },
        {
            "name": "values",
            "baseName": "values",
            "type": "NativeStreamOutputType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamMapOutputType.attributeTypeMap;
    }
    constructor() {
    }
}
